<template>
    <div class="al">
        <el-dialog title="支付宝开户信息" :visible.sync="dialogVisible" width="768px" :before-close="handleClose">
            <div class="main scroll-auto">
                <div class="step">
                    <el-steps :space="200" :active="step" align-center finish-status="success">
                        <el-step title="确认信息"></el-step>
                        <el-step title="填写资质信息"></el-step>
                        <el-step title="填写结算账户"></el-step>
                    </el-steps>
                </div>
                <div class="form-list">
                    <div class="step-0" v-show="step == 0">
                        <el-form :model="ruleFormStep1" :rules="rulesStep1" ref="ruleFormStep1" label-width="160px" class="demo-ruleFormStep1" label-position="right">
                            <el-form-item label="营业执照：" prop="cert_file">
                                <el-upload
                                    action="#"
                                    list-type="picture-card"
                                    :auto-upload="false"
                                    :file-list="ruleFormStep1.cert_file"
                                    :class="ruleFormStep1.cert_file.length == 1 ? 'mf' : ''"
                                    :on-change="(file, fileList) => handleChange(file, fileList, 0)"
                                    :on-remove="(file, fileList) => handleRemove(file, fileList, 0)"
                                >
                                    <i slot="default" class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="主体类型：" prop="merchant_type">
                                <el-select v-model="ruleFormStep1.merchant_type">
                                    <el-option value="1" label="企业"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="证件注册号：" prop="cert_no">
                                <el-input v-model="ruleFormStep1.cert_no" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商户名称：" prop="name">
                                <el-input v-model="ruleFormStep1.name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="法定人身份证正面：" prop="legal_cert_front_file">
                                <el-upload
                                    action="#"
                                    list-type="picture-card"
                                    :auto-upload="false"
                                    :file-list="ruleFormStep1.legal_cert_front_file"
                                    :class="ruleFormStep1.legal_cert_front_file.length == 1 ? 'mf' : ''"
                                    :on-change="(file, fileList) => handleChange(file, fileList, 1)"
                                    :on-remove="(file, fileList) => handleRemove(file, fileList, 1)"
                                >
                                    <i slot="default" class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="法定人身份证反面：" prop="legal_cert_back_file">
                                <el-upload
                                    action="#"
                                    list-type="picture-card"
                                    :auto-upload="false"
                                    :file-list="ruleFormStep1.legal_cert_back_file"
                                    :class="ruleFormStep1.legal_cert_back_file.length == 1 ? 'mf' : ''"
                                    :on-change="(file, fileList) => handleChange(file, fileList, 2)"
                                    :on-remove="(file, fileList) => handleRemove(file, fileList, 2)"
                                >
                                    <i slot="default" class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="法人证件类型：" prop="type" required>
                                <el-select v-model="ruleFormStep1.type">
                                    <el-option value="1" label="中国大陆居民-身份证"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="法人身份证姓名：" prop="legal_name">
                                <el-input v-model="ruleFormStep1.legal_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="法人身份证号码：" prop="legal_cert_no">
                                <el-input v-model="ruleFormStep1.legal_cert_no" clearable></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="step-1" v-show="step == 1">
                        <el-form :model="ruleFormStep2" :rules="rulesStep2" ref="ruleFormStep2" label-width="160px" class="demo-ruleFormStep1" label-position="right">
                            <el-form-item label="商户简称：" prop="alias_name">
                                <el-input v-model="ruleFormStep2.alias_name" clearable></el-input>
                                <p class="tip">将在支付完成页向买家展示</p>
                            </el-form-item>
                            <el-form-item label="商户类别码：" prop="mcc">
                                <el-input v-model="ruleFormStep2.mcc" clearable></el-input>
                                <p class="tip">行业类别码MCC，<a href="https://gw.alipayobjects.com/os/bmw-prod/b28421ce-0ddf-422f-9e9c-c2c3c7f30c73.xlsx">点击下载</a></p>
                            </el-form-item>
                            <el-form-item label="商户行业资质类型：" prop="industry_qualification_type">
                                <el-input v-model="ruleFormStep2.industry_qualification_type" clearable></el-input>
                                <p class="tip">特殊行业要按照MCC说明中的资质一栏上传辅助资质，<a href="https://mif-pub.alipayobjects.com/QualificationType.xlsx">点击下载《资质表》</a></p>
                            </el-form-item>
                            <el-form-item label="商户行业资质图片：" prop="industry_qualification_image">
                                <el-upload
                                    action="#"
                                    list-type="picture-card"
                                    :auto-upload="false"
                                    :file-list="ruleFormStep2.industry_qualification_file"
                                    :class="ruleFormStep2.industry_qualification_file.length == 1 ? 'mf' : ''"
                                    :on-change="(file, fileList) => handleChange(file, fileList, 3)"
                                    :on-remove="(file, fileList) => handleRemove(file, fileList, 3)"
                                >
                                    <i slot="default" class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="step-2" v-show="step == 2">
                        <el-form :model="ruleFormStep3" :rules="rulesStep3" ref="ruleFormStep3" label-width="160px" class="demo-ruleFormStep1" label-position="right">
                            <el-form-item label="商户联系人姓名：" prop="contact_infos_name">
                                <el-input v-model="ruleFormStep3.contact_infos_name" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="商户联系人手机：" prop="contact_infos_mobile">
                                <el-input v-model="ruleFormStep3.contact_infos_mobile" clearable></el-input>
                            </el-form-item>
                            <el-form-item label="结算类型：" prop="default_settle_type">
                                <el-select v-model="ruleFormStep3.default_settle_type">
                                    <el-option value="default_settle_type" label="只支持结算到支付宝账号"></el-option>
                                </el-select>
                            </el-form-item>
                          <!--   <el-form-item label="结算目标：" prop="alipay_logon_id">
                                <el-input v-model="ruleFormStep3.alipay_logon_id" clearable></el-input>
                            </el-form-item> -->
                            <el-form-item label="签约支付宝账户：" prop="binding_alipay_logon_id">
                                <el-input v-model="ruleFormStep3.binding_alipay_logon_id" clearable></el-input>
                                <p class="tip">用于协议确认，且实名认证支付宝账户</p>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <div v-show="step == 0">
                    <el-button type="primary" @click="Next('ruleFormStep1')">下一步</el-button>
                </div>
                <div v-show="step == 1">
                    <el-button type="primary" @click="step -= 1">上一步</el-button>
                    <el-button type="primary" @click="Next('ruleFormStep2')">下一步</el-button>
                </div>
                <div v-show="step == 2">
                    <el-button type="primary" @click="step -= 1">上一步</el-button>
                    <el-button type="primary" @click="submit('ruleFormStep3')">提 交</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data() {
        var checkIdCard = (rule, value, cb) => {
            const regIdCard = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
            if (regIdCard.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的身份证号"));
        };
        var checkMobile = (rule, value, cb) => {
            const regMobile = /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
            if (regMobile.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的手机号"));
        };
        return {
            dialogVisible: false,
            step: 0,
            ruleFormStep1: {
                type: "",
                name: "",
                merchant_type: "",
                cert_no: "",
                cert_image: "",
                cert_file: [],
                legal_cert_front_file: [],
                legal_cert_back_file: [],
                legal_cert_front_image: "",
                legal_cert_back_image: "",
                legal_name: "",
                legal_cert_no: "",
            },
            rulesStep1: {
                type: [{ required: true, message: "请选择法人证件类型", trigger: "change" }],
                name: [{ required: true, message: "请输入商户名称", trigger: "blur" }],
                merchant_type: [{ required: true, message: "请选择主体类型", trigger: "change" }],
                cert_no: [{ required: true, message: "请输入证件注册号", trigger: "blur" }],
                cert_file: [{ required: true, message: "请上传营业执照", trigger: "change" }],
                legal_cert_front_file: [{ required: true, message: "请上传法定人身份证", trigger: "change" }],
                legal_cert_back_file: [{ required: true, message: "请上传法定人身份证", trigger: "change" }],
                legal_name: [{ required: true, message: "请输入法人身份证姓名", trigger: "blur" }],
                legal_cert_no: [
                    { required: true, message: "请输入法人身份证号码", trigger: "blur" },
                    { validator: checkIdCard, trigger: "blur" },
                ],
            },
            ruleFormStep2: {
                alias_name: "",
                mcc: "",
                industry_qualification_type: "",
                industry_qualification_image: "",
                industry_qualification_file: [],
            },
            rulesStep2: {
                alias_name: [{ required: true, message: "请输入商户简称", trigger: "blur" }],
                mcc: [{ required: true, message: "请输入商户类别码", trigger: "blur" }],
            },
            ruleFormStep3: {
                contact_infos_name: "",
                contact_infos_mobile: "",
                default_settle_type: "",
             //   alipay_logon_id: "",
                binding_alipay_logon_id: "",
            },
            rulesStep3: {
                contact_infos_name: [{ required: true, message: "请输入商户联系人姓名", trigger: "blur" }],
                contact_infos_mobile: [
                    { required: true, message: "请输入商户联系人手机", trigger: "blur" },
                    { validator: checkMobile, trigger: "blur" },
                ],
                default_settle_type: [{ required: true, message: "请选择结算类型", trigger: "change" }],
               // alipay_logon_id: [{ required: true, message: "请输入结算目标", trigger: "blur" }],
                binding_alipay_logon_id: [{ required: true, message: "请输入签约支付宝账户", trigger: "blur" }],
            },
        };
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            alipaySubmitUploadFile: "activity/alipaySubmitUploadFile",
            alipaySubmitCreate: "activity/alipaySubmitCreate",
            uploadFile: "commodity/uploadFile",
        }),
        Next(formName) {
              this.step += 1;
            // this.$refs[formName].validate((valid) => {
            //     if (valid) {
            //         this.step += 1;
            //     } else {
            //         console.log("error submit!!");
            //         return false;
            //     }
            // });
        },
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let { name, merchant_type, cert_no, cert_image, legal_cert_front_image, legal_cert_back_image, legal_name, legal_cert_no } = this.ruleFormStep1;
                    let { alias_name, mcc, industry_qualification_type, industry_qualification_image } = this.ruleFormStep2;
                    let { contact_infos_name, contact_infos_mobile, default_settle_type, binding_alipay_logon_id } = this.ruleFormStep3;
                /*     let { contact_infos_name, contact_infos_mobile, default_settle_type, alipay_logon_id, binding_alipay_logon_id } = this.ruleFormStep3; */
                    let params = {
                        token: this.getToken,
                        name: name,
                        alias_name: alias_name,
                        merchant_type: merchant_type,
                        mcc: mcc,
                        cert_no: cert_no,
                        cert_image: cert_image,
                      //  alipay_logon_id: alipay_logon_id,
                        binding_alipay_logon_id: binding_alipay_logon_id,
                        contact_infos: {
                            name: contact_infos_name,
                            mobile: contact_infos_mobile,
                        },
                        legal_name: legal_name,
                        legal_cert_no: legal_cert_no,
                        legal_cert_front_image: legal_cert_front_image,
                        legal_cert_back_image: legal_cert_back_image,
                        default_settle_rule: {
                            default_settle_type: default_settle_type,
                          //  default_settle_target: alipay_logon_id,
                        },
                        qualifications: {
                            industry_qualification_type: industry_qualification_type,
                            industry_qualification_image: industry_qualification_image,
                        },
                    };
                    this.alipaySubmitCreate(params).then(({ data }) => {
                        console.log(res);
                        if (data.code == 1) {
                            this.$message.success("提交成功！");
                            this.handleClose();
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleClose() {
            this.dialogVisible = false;
            this.step = 0;
            this.$refs.ruleFormStep1.resetFields();
            this.$refs.ruleFormStep2.resetFields();
            this.$refs.ruleFormStep3.resetFields();
            this.ruleFormStep1 = {
                type: "",
                name: "",
                merchant_type: "",
                cert_no: "",
                cert_image: "",
                cert_file: [],
                legal_cert_front_file: [],
                legal_cert_back_file: [],
                legal_cert_front_image: "",
                legal_cert_back_image: "",
                legal_name: "",
                legal_cert_no: "",
            };
            this.ruleFormStep2 = {
                alias_name: "",
                mcc: "",
                industry_qualification_type: "",
                industry_qualification_image: "",
                industry_qualification_file: [],
            };
            this.ruleFormStep3 = {
                contact_infos_name: "",
                contact_infos_mobile: "",
                default_settle_type: "",
              //  alipay_logon_id: "",
                binding_alipay_logon_id: "",
            };
        },
        handleChange(file, fileList, index) {
            var formdata = new FormData();
            formdata.append("formdata", file.raw);
            switch (index) {
                case 0:
                    this.ruleFormStep1.cert_file = fileList;
                    if (this.ruleFormStep1.cert_file.length > 0) {
                        this.$refs.ruleFormStep1.clearValidate("cert_file");
                    }
                    break;
                case 1:
                    this.ruleFormStep1.legal_cert_front_file = fileList;
                    if (this.ruleFormStep1.legal_cert_front_file.length > 0) {
                        this.$refs.ruleFormStep1.clearValidate("legal_cert_front_file");
                    }
                    break;
                case 2:
                    this.ruleFormStep1.legal_cert_back_file = fileList;
                    if (this.ruleFormStep1.legal_cert_back_file.length > 0) {
                        this.$refs.ruleFormStep1.clearValidate("legal_cert_back_file");
                    }
                    break;
                case 3:
                    this.ruleFormStep2.industry_qualification_file = fileList;
                    break;
                default:
                    break;
            }
            this.uploadFile(formdata).then((res) => {
                if (res.code == 1) {
                    // console.log(res);
                    this.$message.success("上传成功！");
                    switch (index) {
                        case 0:
                            this.ruleFormStep1.cert_image = res.data.formdata_details[0].urls;
                            break;
                        case 1:
                            this.ruleFormStep1.legal_cert_front_image = res.data.formdata_details[0].urls;
                            break;
                        case 2:
                            this.ruleFormStep1.legal_cert_back_image = res.data.formdata_details[0].urls;
                            break;
                        case 3:
                            this.ruleFormStep2.industry_qualification_image = res.data.formdata_details[0].urls;
                            break;
                        default:
                            break;
                    }
                } else {
                    this.$message({
                        type: "warning",
                        message: res.msg,
                    });
                }
            });
        },
        handleRemove(file, fileList, index) {
            switch (index) {
                case 0:
                    this.ruleFormStep1.cert_file.map((item, index) => {
                        if (item.name == file.name) {
                            this.ruleFormStep1.cert_file.splice(index, 1);
                            this.rulesStep1.cert_file = [{ required: true, message: "请上传营业执照", trigger: "change" }];
                        }
                    });
                    break;
                case 1:
                    this.ruleFormStep1.legal_cert_front_file.map((item, index) => {
                        if (item.name == file.name) {
                            this.ruleFormStep1.legal_cert_front_file.splice(index, 1);
                            if (item.name == file.name) {
                                this.ruleFormStep1.cert_file.splice(index, 1);
                                this.rulesStep1.legal_cert_front_file = [{ required: true, message: "请上传法定人身份证", trigger: "change" }];
                            }
                        }
                    });
                    break;
                case 2:
                    this.ruleFormStep1.legal_cert_back_file.map((item, index) => {
                        if (item.name == file.name) {
                            this.ruleFormStep1.legal_cert_back_file.splice(index, 1);
                            if (item.name == file.name) {
                                this.ruleFormStep1.cert_file.splice(index, 1);
                                this.rulesStep1.cert_file = [{ required: true, message: "请上传法定人身份证", trigger: "change" }];
                            }
                        }
                    });
                    break;
                case 3:
                    this.ruleFormStep2.industry_qualification_file.map((item, index) => {
                        if (item.name == file.name) {
                            this.ruleFormStep2.industry_qualification_file.splice(index, 1);
                        }
                    });
                    break;
                default:
                    break;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.al {
    .main {
        max-height: 500px;
        .step {
            text-align: center;
            margin-bottom: 40px;
            .el-steps {
                justify-content: center;
            }
        }
        .form-list {
            ::v-deep .el-input--medium .el-input__inner,
            .el-input {
                width: 400px !important;
            }
        }
    }
    .tip {
        font-size: 12px;
        color: #999;
    }
}
.mf {
    ::v-deep .el-upload--picture-card {
        display: none !important;
    }
}
</style>